var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_vm._v(" Seleccione un juego ")])
}
var staticRenderFns = []

export { render, staticRenderFns }